import React, { useContext, useEffect } from "react";
import "../styles/CellarView.css"; 
import { CellarContext } from "../contexts/CellarContext";
import CellarBeerView from "./CellarBeerView";

function CellarView({ userSafeEmail }) {
    const {
        beers,
        totalPanels,
        processing,
        getCellarEntries,
    } = useContext(CellarContext);

    // const [isPhone, setIsPhone] = useState(true); // you can detect screen size
    // or omit if you always want 3 columns

    useEffect(() => {
        getCellarEntries(userSafeEmail /*, isPhone*/);
    }, [userSafeEmail/*, isPhone*/, getCellarEntries]);

    // useEffect(() => {
    //     // 1) Decide phone vs not phone
    //     // e.g. quick check of screen width or user agent
    //     if (window.innerWidth > 900) {
    //         setIsPhone(false);
    //     }

    // }, []);

    // Each “panel” has 7 rows. Each row has 3 columns if phone, else 4.
    const phoneCols = 3;
    // const tabletCols = 4;
    
    if (processing) return <div>Loading Cellar...</div>;
    
    return (
        <div className="cellar-container">
            {/* For each panel */}
            {Array.from({ length: totalPanels }).map((_, panelIndex) => (
                <div key={panelIndex} className="cellar-panel">
                    {/* Shelves background */}
                    <img src="/images/Shelves.png" alt="Shelves" className="shelves-bg" />

                    {/* 7 rows */}
                    <div className="rows-container">
                        {Array.from({ length: 7 }).map((_, rowIndex) => (
                            <div key={rowIndex} className="beer-row">
                                {/* phone => 3 columns, else => 4 columns */}
                                {Array.from({
                                    length: phoneCols, //isPhone ? phoneCols : tabletCols,
                                }).map((_, colIndex) => {
                                    // which beer index overall?
                                    const chunkSize = 21 //isPhone ? 21 : 28; // 21 if phone, 28 if tablet
                                    const beerIndex =
                                        panelIndex * chunkSize + rowIndex * (phoneCols /*isPhone ? phoneCols : tabletCols*/) + colIndex;
                                    if (beerIndex < beers.length) {
                                        const thisBeer = beers[beerIndex];
                                        return (
                                            <CellarBeerView
                                                key={beerIndex}
                                                beer={thisBeer}
                                                quantity={thisBeer.quantity}
                                            // pass any props needed
                                            />
                                        );
                                    } else {
                                        // No beer => show empty slot
                                        return <div key={colIndex} className="empty-slot" />;
                                    }
                                })}
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

// This replicates your “CellarBeerView” from Swift:
// function CellarBeerView({ beer }) {
//     const handleTap = () => {
//         console.log(`Tap on beer: ${beer.craftBeerEntry.beerName}`);
//         // e.g. navigate to Beer detail or set some state
//     };

//     const handleDoubleTap = () => {
//         console.log(`Double tap => maybe show delete for ${beer.craftBeerEntry.beerName}`);
//         // e.g. call removeFromCellar
//     };

//     return (
//         <div
//             className="cellar-beer-view"
//             onClick={handleTap}
//             onDoubleClick={handleDoubleTap}
//         >
//             {/* Possibly show an image for the can/bottle, etc. */}
//             <div className="beer-image-container">
//             {beer.craftBeerEntry.beerImage && (
//                 <img
//                     src={beer.craftBeerEntry.beerImage}
//                     alt={beer.craftBeerEntry.beerName}
//                     className="beer-image"
//                 />
//             )}
//             </div>
//         </div>
//     );
// }

export default CellarView;
